import AxiosClientService from '@/services/core/axios/axios';
import { APP_HOST } from '@/app.config';

class KzsTemplateApi {
  constructor() {
    this.api = AxiosClientService.instance;
  }
  /**
   *  Метод для получения списка шаблонов задач КЗС
   * @param {Object} params - Параметры запроса
   * @param {string} params.templateName - Строка поиска
   * @param {number} params.page - Номер страницы
   * @param {number} params.limit - Количество шаблонов задач КЗС на странице
   * @returns
   */

  async getKzsTemplateList(params) {
    const { data } = await this.api.get(`${APP_HOST}v2/monitoring/assignment-templates/list`, { params });
    return data;
  }

  /**
   *  Метод для получения шаблона задачи КЗС по ID
   * @param {string} id - ID шаблона задачи КЗС
   * @returns
   */
  async getKzsTemplateById(id) {
    const { data } = await this.api.get(`${APP_HOST}v2/monitoring/assignment-templates/${id}`);
    return data;
  }

  /**
   *  Метод для создания шаблона задачи КЗС
   * @param {Object} params - Параметры запроса
   * @param {string} params.name - Наименование шаблона задачи КЗС
   * @param {Array} params.diagnoses - Массив диагнозов
   * @param {string} params.description - Описание шаблона задачи КЗС
   * @returns
   */
  async createKzsTemplate(params) {
    const { data } = await this.api.post(`${APP_HOST}v2/monitoring/assignment-templates/create`, params);
    return data;
  }

  /**
   *  Метод для удаления шаблона задачи КЗС
   * @param {string} id - ID шаблона задачи КЗС
   * @returns
   */
  async deleteKzsTemplate(id) {
    const { data } = await this.api.delete(`${APP_HOST}v2/monitoring/assignment-templates/${id}`);
    return data;
  }

  /**
    *  Метод для обновления шаблона задачи КЗС
   * @param {string} id - ID шаблона задачи КЗС
   * @param {Object} params - Параметры запроса
   * @param {string} params.name - Наименование шаблона задачи КЗС
   * @param {Array} params.diagnoses - Массив диагнозов
   * @param {string} params.description - Описание шаблона задачи КЗС
   * @returns
   */
  async updateKzsTemplate(id, params) {
    const { data } = await this.api.put(`${APP_HOST}v2/monitoring/assignment-templates/update/${id}`, params);
    return data;
  }

    /**
   *  Метод для получения списка шаблонов задач КЗС
   * @returns
   */
  async getShortKzsTemplateList() {
    const { data } = await this.api.get(`${APP_HOST}v2/monitoring/assignment-templates/list/short`);
    return data;
  }
}
export default KzsTemplateApi;
